import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  NgZone,
  OnInit,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { FileAnswer } from 'src/app/models/Answer.model';
import { DragDirective } from 'src/app/directves/drag.directive';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { DocumentCameraComponent } from 'src/app/features/camera/document-camera/document-camera.component';
import { UploadFileStore } from 'src/app/store/uplod-file.store';
import { NotificationService } from 'src/app/shared/services/notification.service';
@Component({
    selector: 'que-upload-file-local-display',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DragDirective,
        TranslateDirective, TranslatePipe,
        SvgIconComponent,
        OverlayModule,
        DocumentCameraComponent,
    ],
    templateUrl: './upload-file-local-display.component.html',
    styleUrls: ['./upload-file-local-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UploadFileLocalDisplayComponent,
            multi: true,
        },
        UploadFileStore,
    ]
})
export class UploadFileLocalDisplayComponent
  implements ControlValueAccessor, OnInit
{
  constructor(
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {}

  @Input() isMulty?: boolean;
  @Input() isUser?: boolean;
  @Input() isIcon?: boolean;
  #uploadFileStore = inject(UploadFileStore);
  #notification = inject(NotificationService);
  answer = new FormControl<FileAnswer[]>([]);
  filesSig$ = signal<FileAnswer[]>([]);
  registerOnChangeCallback: any = () => {};
  isOpen: boolean = false;
  positonArea: ConnectedPosition[] = [
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
    },
  ];
  ngOnInit(): void {
    this.answer.valueChanges.subscribe((ans) => {
      console.log(
        `[UploadFileLocal] answer.valueChanges → files:`,
        ans?.length,
        ans?.map((f: any) => f.fileName),
      );
      this.filesSig$.set(ans ?? []);
      this.registerOnChangeCallback(ans);
    });
  }

  writeValue(obj: FileAnswer[] | null | undefined): void {
    const files = Array.isArray(obj) ? obj : [];
    console.log(
      `[UploadFileLocal] writeValue → files:`,
      files?.length,
      files?.map((f: any) => f.fileName),
    );
    console.trace('[UploadFileLocal] writeValue trace');
    this.answer.setValue(files, { emitEvent: false });
    this.filesSig$.set(files);
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {}
  onFileChange(input: HTMLInputElement): void {
    if (!this.isUser) return;

    const files = input.files;
    if (!files || files.length === 0) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!allowedTypes.includes(file.type)) {
        continue;
      }

      this.uploadFileToBucket(file);
      if (!this.isMulty) {
        break;
      }
    }

    input.value = '';
  }
  uploadFileToBucket(file: File): void {
    this.#uploadFileStore.uploadFile({
      file,
      onSuccess: (uploadedFile) => {
        this.ngZone.run(() => {
          const currentFiles = this.isMulty ? (this.answer.value ?? []) : [];

          const uploadedFileWithPreview: FileAnswer = {
            ...uploadedFile,
            base64: null,
            previewUrl: URL.createObjectURL(file),
          };

          const alreadyExists = currentFiles.some(
            (currentFile) =>
              currentFile.objectName === uploadedFile.objectName ||
              currentFile.guid === uploadedFile.guid,
          );

          if (alreadyExists) {
            return;
          }

          const updatedFiles = [...currentFiles, uploadedFile];

          this.answer.setValue(updatedFiles);
        });
      },
    });
  }
  readFileAsBase64(file: File): void {
    const reader = new FileReader();

    reader.onloadend = () => {
      this.ngZone.run(() => {
        const result = reader.result as string;
        const base64Data = result.split(',')[1];
        const newFileAnswer: FileAnswer = {
          id: 0,
          fileName: file.name,
          base64: base64Data,
          mimeType: file.type,
          guid: null,
        };

        const currentFiles = this.answer.value ?? [];
        this.answer.setValue([...currentFiles, newFileAnswer]);
      });
    };

    reader.readAsDataURL(file);
  }

  remove(i: number) {
    if (!this.isUser) return;

    this.answer.setValue(
      this.answer.value?.filter((_, index) => index !== i) || [],
    );

    this.isOpen = false;
  }

  async filesDroped(files: FileList) {
    if (!this.isUser) return;
    if (!files?.length) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!allowedTypes.includes(file.type)) {
        continue;
      }

      this.uploadFileToBucket(file);

      if (!this.isMulty) break;
    }
  }
  getFileExtension(fileName: string): string {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts.pop()!.toUpperCase() : 'קובץ';
  }

  previewLocalFile(file: FileAnswer): void {
    if (!file.base64) return;

    const mimeType = file.mimeType || 'application/octet-stream';

    const byteCharacters = atob(file.base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');
  }

  get isUploadEnabled(): boolean {
    return this.isMulty || this.answer.value?.length == 0;
  }

  previewFile(file: FileAnswer): void {
    if (file.previewUrl) {
      window.open(file.previewUrl, '_blank');
      return;
    }
    if (file.base64) {
      this.previewLocalFile(file);
      return;
    }
    if (file.guid) {
      window.open(`/viewFile/${file.guid}`, '_blank');
      return;
    }
    console.warn('[UploadFileLocal] file cannot be previewed', file);
  }

  shortFileName(fileName?: string): string {
    if (!fileName) return '';

    return fileName.length > 13 ? fileName.slice(0, 10) + '...' : fileName;
  }

  getCanUpload() {
    return this.isUser && this.filesSig$().length < 5;
  }
  addCapturedFile(file: File): void {
    if (!this.isUser) return;

    if (!this.getCanUpload()) {
      this.#notification.showError({
        en: 'You cannot add more files',
        he: 'לא ניתן להוסיף יותר קבצים',
      });
      return;
    }

    this.uploadFileToBucket(file);
    this.isOpen = true;
    this.cdr.markForCheck();
  }
}
